import React from "react";
import FileRecordsPane, { FileRecordsConfig } from "./FileRecordsPane";
import { UserProfile } from "../../types/objects";

const CONFIG: FileRecordsConfig = {
    resource: "contracts",
    title: "Smlouvy",
    subtitle: "Uzavřené smlouvy a jejich přílohy.",
    nounAccusative: "Smlouvu",
    emptyLabel: "V seznamu zatím nejsou žádné smlouvy.",
};

export default function Contracts({ user }: { user: UserProfile }) {
    return <FileRecordsPane user={user} config={CONFIG} />;
}
